import { Component, OnInit, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { IntlService } from '@progress/kendo-angular-intl';
import { State } from '@progress/kendo-data-query';
import { PageBaseComponent } from './page-base.component';
import { AuthService, DatasourceService } from '@app/core/services';
import { DialogService, DialogRef, DialogCloseResult } from "@progress/kendo-angular-dialog";
import { MultipleImagenUploadComponent } from '@app/components/uploads'
import { UploadComponent } from '@progress/kendo-angular-upload';
// import { User } from '@app/core/models';


@Component({
  selector: 'vehicle-edit-photos',
  styleUrls: ['./styles/styles-wrapper.css', './styles/styles-form.css'],
  styles: [`
    form {
      padding: 0 15px 128px 15px;
    }
  `],    
  template: `

    <div class="wrapper-route-0">

      <vehicle-info [id]="id" (complete)="onComplete($event)"></vehicle-info>

      <form novalidate [formGroup]="form">
        <div class="example-wrapper form-detail">        
          <div class="row">
            <div class="col-field">
              <kendo-label text="Fotografías:"></kendo-label>
              <div class="k-block" *ngIf="loading">
                <kendo-loader [type]="'pulsing'" [size]="'medium'"></kendo-loader>
              </div>
              <multiple-imagen-upload formControlName="photos" [folder]="'vehicles'" (complete)="onUploadComplete($event)" (upload)="onUpload($event)"></multiple-imagen-upload>               
            </div>              
          </div>
        </div>
      </form>

      <kendo-floatingactionbutton icon="arrow-left" themeColor="secondary" [offset]="{ x: '12px', y: '68px' }" [align]="{ horizontal: 'start', vertical: 'bottom' }" positionMode="fixed" (click)="goBack()"></kendo-floatingactionbutton>

      <kendo-floatingactionbutton icon="plus" themeColor="success" [offset]="{ x: '80px', y: '68px' }" [align]="{ horizontal: 'end', vertical: 'bottom' }" positionMode="fixed" (click)="onAdd()"></kendo-floatingactionbutton>

      <kendo-floatingactionbutton icon="save" themeColor="info" [offset]="{ x: '12px', y: '68px' }" [align]="{ horizontal: 'end', vertical: 'bottom' }" positionMode="fixed" (click)="onSave()"></kendo-floatingactionbutton>

    </div>
    
    <div kendoDialogContainer></div>

  `
})
export class VehicleEditPhotosComponent extends PageBaseComponent implements OnInit {
    
  @ViewChild(MultipleImagenUploadComponent, {static: false}) upload !: MultipleImagenUploadComponent;

  public id: number = 0;

  public mode = 'EDIT';

  // public table: string = 'vehicles_inventories';

  public vehicle: any = {};
  
  public form: FormGroup = new FormGroup({
      'photos': new FormControl([])
  });

  public loading = false;


  constructor(public authService: AuthService, protected router: Router, protected route: ActivatedRoute, protected service : DatasourceService, protected intl: IntlService, private dialogService: DialogService) { 

    super(authService, router)
    // console.log('VehicleEditPhotosComponent');
    let id = this.route.snapshot.paramMap.get('id');
    this.id = (id != null) ? parseInt(id): 0; 

    let state : State = {
      skip: 0, 
      take: 0, 
      // sort: [{field: 'sku_exp', dir: 'desc'}], 
      filter: {
        logic: "and",
        filters: [
          {
            field: 'id_vehicle_inventory',
            operator: 'eq',
            value: id
          }
        ]
      }, 
      group: []
    }

    this.loading = true;

    this.service.get('vehicles_inventories_photos', state)
      .subscribe(
        (res: any) => {
          console.log("RESPONSE------: ", res);
          this.form.patchValue({
            photos: res.data.map(function (gallery: any) {
              return {uid: gallery.id, src: gallery.photo, deleted: 0}; 
            })
          });

          this.loading = true;
        },
        (fail: any) => {        
          console.log("Error", fail);
        },
        () => {
          this.loading = false;
        }
      );

  }

  public onComplete(event: any) {

    this.vehicle = event.dataItem;

  }

  protected getFormGroup(): FormGroup {

    return new FormGroup({
      'id': new FormControl(this.vehicle.id, Validators.required),
      'photos': new FormControl([]),
    });

  };

  ngOnInit() {

    this.form = this.getFormGroup();

  }

  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  protected getData(formGroup: FormGroup): Object {

    return Object.assign({}, formGroup.value, {
        // id_vehicle_status: 2
      });

  };

  public onSave(): void {
  
    let data = this.getData(this.form);
    console.log('data', data)

    // this.loading = true;

    if(this.mode == 'EDIT'){

      // GUARDAR FOTOS.
      this.form.value.photos.forEach((row: any) => { 
        row['id_vehicle_inventory'] = this.vehicle.id;
        row['photo'] = row.src;
      });

      console.log(this.form.value.photos);

      this.service.remove_batch('vehicles_inventories_photos', 'id_vehicle_inventory', this.vehicle.id, (table: string, res: any)=>{

        //1.- ELIMINAR LOS REGISTROS CON deleted == 1
        let photos = this.form.value.photos.filter((x: any) => x.deleted == 0).map((item : any) => {
            return Object.assign({}, item, { uid: null });
          });
        console.log(photos);
  
        this.service.add_batch('vehicles_inventories_photos', photos, (table: string, res: any)=>{

          console.log(table, res);

          const dialog: DialogRef = this.dialogService.open({
            title: "Éxito",
            content: `Se actualizaron con éxito las fotográfias del folio de expediente: ${this.vehicle.sku_exp}`,
            actions: [{ text: "Ok", primary: true }],
            width: '80%',
            // height: 200,
            // minWidth: 250,
          });
        
          dialog.result.subscribe((result) => {
            if (result instanceof DialogCloseResult) {
                // console.log("close");
            }
            this.goBack();
          });

        });
  
      });

    }
  
  }

  public onUpload(e: any) {

    this.loading = true;

  }

  public onUploadComplete(e: any) {

    this.loading = false;

  }

  public onAdd() {

    var el: UploadComponent = this.upload.input;
    el.fileSelect.nativeElement.click();                
  
  }

  public goBack() {

    // console.log(event);
    this.router.navigate([`/vehicle_actions/${this.id}`]);
  
  }

}